import { useEffect, useState } from "react";
import type { DataTableColumnVisibility } from "./tableTypes";

export function useColumnVisibility(storageKey: string, initialVisibility: DataTableColumnVisibility = {}) {
  const storageId = `salesko:data-table:${storageKey}:columns`;
  const [columnVisibility, setColumnVisibility] = useState<DataTableColumnVisibility>(() => {
    if (typeof window === "undefined") {
      return initialVisibility;
    }

    try {
      const stored = window.localStorage.getItem(storageId);
      return stored ? { ...initialVisibility, ...JSON.parse(stored) } : initialVisibility;
    } catch {
      return initialVisibility;
    }
  });

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    window.localStorage.setItem(storageId, JSON.stringify(columnVisibility));
  }, [columnVisibility, storageId]);

  return [columnVisibility, setColumnVisibility] as const;
}
